import { Section } from '@tracklib/kit'

import formatHtml from 'components/staticpages/formathtml'

import styles from './infoblock.css'

type InfoBlockProps = {
  value: {
    items: [{ text: string }]
  }
}

const InfoBlock = ({ value }: InfoBlockProps) => (
  <Section size="medium">
    <div className={styles.wrapper}>
      <span className={styles.ornament} />
      <ul className={styles.content}>
        {value.items.map((item, i) => {
          const html = formatHtml(item.text)
          return <li dangerouslySetInnerHTML={{ __html: html }} key={String(i)} />
        })}
      </ul>
    </div>
  </Section>
)

export default InfoBlock
